import { IconCalendar, IconClock } from '@/components/Icon';

const MONTHS_FR = [
  'janv.', 'févr.', 'mars', 'avril', 'mai', 'juin',
  'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.',
];

function formatDateFr(ymd: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return ymd;
  const [y, m, d] = ymd.split('-').map(Number);
  return `${d} ${MONTHS_FR[m - 1] ?? ''} ${y}`;
}

function formatMonthFr(ym: string): string {
  if (!/^\d{4}-\d{2}$/.test(ym)) return ym;
  const [y, m] = ym.split('-').map(Number);
  return `${MONTHS_FR[m - 1] ?? ''} ${y}`;
}

function formatTime24(t: string): string {
  return /^\d{2}:\d{2}/.test(t) ? t.slice(0, 5) : t;
}

type Variant = 'date' | 'month' | 'time';

type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  variant?: Variant;
  required?: boolean;
  min?: string;
  max?: string;
  label?: string;
};

// A <label> wrapping the styled chrome AND the real <input>. The input sits on
// top of the chrome at opacity-0 so the tap goes directly to the native
// control — iOS standalone PWAs reliably open the OS picker on direct tap,
// but reject programmatic showPicker() in nested contexts.
export function DateField({
  value,
  onChange,
  placeholder,
  variant = 'date',
  required,
  min,
  max,
  label,
}: Props) {
  const formatted = !value
    ? ''
    : variant === 'month'
      ? formatMonthFr(value)
      : variant === 'time'
        ? formatTime24(value)
        : formatDateFr(value);

  const Icon = variant === 'time' ? IconClock : IconCalendar;

  return (
    <label className="relative block w-full">
      <div className="w-full rounded-pill bg-white text-brand-darkest px-5 py-3 shadow-card flex items-center justify-between gap-3">
        <span className="flex-1 truncate">
          {formatted || (
            <span className="text-brand-darkest/40">
              {placeholder ?? label ?? 'Choisir…'}
            </span>
          )}
        </span>
        <span aria-hidden className="text-brand-darkest/50 shrink-0">
          <Icon size={18} />
        </span>
      </div>
      <input
        type={variant}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        min={min}
        max={max}
        aria-label={placeholder ?? label}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      />
    </label>
  );
}
